import './mapleeventgroup1/style';
import FormStructure from './mapleeventgroup1/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js